
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"8","height":"14","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.433 6.702a1.093 1.093 0 0 0-.255-.606L2.28.366a1.087 1.087 0 0 0-1.858.34c-.13.37-.054.78.2 1.076l4.294 5.022-4.294 5.022a1.094 1.094 0 0 0 .631 1.784c.384.07.775-.07 1.027-.368l4.898-5.73c.19-.225.283-.517.255-.81z","fill":"#FFF","fill-rule":"nonzero"}})])
      }
    
      }
    